import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form} from "react-bootstrap";
import { getCategories, getUsers, getTemplates } from "../../utils/api";
import TemplatesTable from "./TemplatesTable";
import { useHorizontalScroll } from "../elements/useSideScroll";
import CategoryButtons from "../elements/CategoryButtons";
import { ColoredLine } from "../elements/ColoredLine";
import { checkUserToken } from "../../utils/checkUser";

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faAngleRight, faAngleLeft )

const Templates = ({chosenDepartment, departmentPermission}) => {
  const scrollRef = useHorizontalScroll();
  const [templates, setTemplates] = useState([]);
  const [templatesVisible, setTemplatesVisible] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [categories, setCategories] = useState([]);
  const [users, setUsers] = useState([]);

  const [chosenCategory, setChosenCategory] = useState("All")

  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
  const [scrolEnd, setscrolEnd] = useState(false); // For detecting end of scrolling


  useEffect(() => {
    getUsers(setUsers);
    checkUserToken();
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  //Check if we need to display the right scroll button
  useEffect(() => {
    scrollCheck();
  }, [scrollRef?.current?.scrollWidth, scrollRef?.current?.offsetWidth])

  useEffect(() => {
    if ( chosenDepartment !== "" && chosenDepartment !== undefined) {
      getTemplates(setTemplates, chosenDepartment, chosenCategory);
      getCategories(setCategories, chosenDepartment);
    }
    setChosenCategory("All")
  }, [chosenDepartment])
  
  useEffect(() => {
    if ( chosenDepartment !== "" && chosenDepartment !== undefined) {
      getTemplates(setTemplates, chosenDepartment, chosenCategory);
    }
  }, [chosenCategory])


  //Search function
  useEffect(() => {
    setTemplatesVisible(
      templates.filter((template) => {
        return (
          template.name.toLowerCase().includes(searchText.toLowerCase()) ||
          template.description.toLowerCase().includes(searchText.toLowerCase()) ||
          template._id.toLowerCase().includes(searchText.toLowerCase())  
        );
      })
    ); 
  }, [searchText, templates]);

  //Category Scrolling
  const scroll = (scrollOffset) => {
    scrollRef.current.scrollLeft += scrollOffset;
  };
  
  const scrollCheck = () => {

    setscrollX(scrollRef.current.scrollLeft);

    if (
      Math.floor(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft) <=
      scrollRef.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  const handleResize = () => {
    if (
      scrollRef.current &&
      scrollRef?.current?.scrollWidth === scrollRef?.current?.offsetWidth      
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
    return () => {};
  };

  
  return (
    <Container fluid className="main-container">
      <Row className="row-header">
          <h2 className="page-header">Templates</h2>
      </Row>
      <ColoredLine color="#DEDEDE" />

    
      <Row className="row-level-2" >
        <h5 className="filter-headers">Category</h5> 
      </Row>
      <Row className="categories-row">
          <Container fluid className="categories-container"  ref={scrollRef} onScroll={scrollCheck}>
            <CategoryButtons setChosenCategory={setChosenCategory} chosenCategory={chosenCategory} categories={categories} /> 
          </Container>
      </Row>
      {(scrollX !== 0 || !scrolEnd) &&
        <Row>
          <Col xs={12} style={{textAlign: "center"}}>
              <Button variant="light" className="left-scroll-button" onClick={() => scroll(-50)} disabled={scrollX === 0}>
                  <FontAwesomeIcon icon={faAngleLeft}  size='1x' className='all-font-icons left-scroll-icon'  />
              </Button>
            
            <Button variant="light" className="right-scroll-button" onClick={() => scroll(+50)} disabled={scrolEnd}>
              <FontAwesomeIcon icon={faAngleRight}  size='1x' className='all-font-icons left-scroll-icon' />
            </Button>

          </Col>
        </Row>
      }

      <Row style={{marginTop: (scrollX === 0 && scrolEnd) && "10px"}}>
          <Col xs={9} sm={7} md={6}>
            <h5 className="filter-headers">Search</h5>
            <Form.Control
              onChange={(e) => setSearchText(e.target.value)}
              className="mb-3"
              type="text"
              placeholder="Search name or description..."
            />
          </Col>
      </Row>

      <TemplatesTable templates={templatesVisible} users={users} chosenDepartment={chosenDepartment} />
    </Container>
  );
};

export default Templates;
